<template>
  <footer class="bg-[#7c2622] py-16">
    <div class="mx-auto max-w-[1450px] px-8 lg:px-12">
      <div class="grid md:grid-cols-4 gap-12 mb-12">
        <div class="md:col-span-2">
          <router-link to="/" class="flex items-center gap-2 mb-4">
            <img
                src="/Singapore-Top-Souvenir-Award-Logo.png"
                alt="Souvenir Excellence Awards Logo"
                class="h-10 md:h-12 w-auto"
            />
            <span class="font-serif text-lg font-semibold text-white">
              Souvenir Excellence Awards
            </span>
          </router-link>

          <p class="text-sm text-white/70 leading-relaxed max-w-sm">
            Administered by the Souvenir & Cultural Retail Association,
            dedicated to promoting quality standards and celebrating excellence
            in the souvenir industry.
          </p>
        </div>

        <div>
          <h4 class="font-medium text-white mb-4">
            Quick Links
          </h4>

          <ul class="space-y-2">
            <li>
              <router-link to="/about" class="text-sm text-white/70 hover:text-white transition-colors">
                About the Award
              </router-link>
            </li>
            <li>
              <router-link to="/categories" class="text-sm text-white/70 hover:text-white transition-colors">
                Award Categories
              </router-link>
            </li>
            <li>
              <router-link to="/judging" class="text-sm text-white/70 hover:text-white transition-colors">
                Judging Process
              </router-link>
            </li>
            <li>
              <router-link to="/timeline" class="text-sm text-white/70 hover:text-white transition-colors">
                Key Dates
              </router-link>
            </li>
          </ul>
        </div>

      </div>

      <div class="pt-8 border-t border-white/20">
        <div class="flex flex-col md:flex-row justify-between items-center gap-4">
          <p class="text-xs text-white/50">
            © 2026 Souvenir & Cultural Retail Association. All rights reserved.
          </p>

          <!-- <div class="flex gap-6">
            <a href="#" class="text-xs text-white/50 hover:text-white transition-colors">
              Terms & Conditions
            </a>
            <a href="#" class="text-xs text-white/50 hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" class="text-xs text-white/50 hover:text-white transition-colors">
              Disclaimer
            </a>
          </div> -->
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PageFooter",
}
</script>